import { render } from "./ProviderCallback.vue?vue&type=template&id=708b1999"
import script from "./ProviderCallback.vue?vue&type=script&lang=js"
export * from "./ProviderCallback.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__